<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="设备状态"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div :style="{ height: pageHeight-46 + 'px' }" style="position: relative;margin-top:46px;">
      <ul class="legend" v-show="listType.length>0">
        <li v-show="show1">
          <h6>行波模块设备</h6>
          <p><i></i><span>断路器分</span></p>
          <p><i></i><span>断路器合</span></p>
          <p><i></i><span>通讯断开</span></p>
        </li>
        <li  v-show="show2">
          <h6>架空型设备<i></i></h6>
        </li>
        <li  v-show="show3">
          <h6>电缆型设备<i></i></h6>
        </li>
      </ul>
      <em class='dw'>
        <img :src="collect? src1 : src2" @click="fixedPos(collect)"/>
      </em>
      <div
        style="height: 100%; width: 100%"
        class="baiduMap"
        id="allmap"
        ref="allmap"
      ></div>
      <!-- <van-popup v-model="show">内容</van-popup> -->
      <div class="information" v-show="mapshow" :class="[{ animated: isActive1 },{ fadeInUp: isActive2 },{ fadeOutDown: isActive3 } ]">
        <h3>设备信息</h3>
        <ul>
          <li v-show="false"><span>设备编号:</span><span>{{elepoId}}</span></li>
          <li v-show="false"><span>设备状态:</span><span>{{dtuStatus}}</span></li>
          <li><span>所属线路:</span><span>{{mlName}}</span></li>
          <li><span>设备位置:</span><span>{{longitudeLatitude}}</span></li>
          <li><span>地理位置:</span><span>{{station}}</span></li>
        </ul>
        <!-- <img src="../assets/jslx@3x.png" alt="" style="border:1px solid red;width:30px;height:30px"> -->
        <!-- <van-button icon="require('../assets/jslx@3x.png')" type="info" block>到这去</van-button> -->
        <van-button :icon="require('../assets/jslx@3x.png')" type="info" block @click="startTOend">到这去</van-button>
      </div>
      <div class="information" v-show="distanceshow" :class="[{ animated: isActive1 },{ fadeInUp: isActive2 },{ fadeOutDown: isActive3 } ]">
        <h3>推荐线路</h3>
        <p>距离您当前位置{{getDistance}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Col,
  Row,
  Button,
  NavBar,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Grid,
  GridItem,
  Popup,
   Dialog
} from 'vant'
// import BMap from 'BMap'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(
  Col,
  Row,
  Button,
  NavBar,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Grid,
  GridItem,
  Popup
)

export default {
  name: 'deviceStatusPage',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Popup.name]: Popup
    // areaMap
  },
  data () {
    return {
      isActive1: true,
      isActive2: true,
      isActive3: false,
      mapshow: false, // 设备信息
      distanceshow: false, // 推荐线路
      collect: true, // 是否定位
      src1: require('../assets/dingwei@3x.png'),
      src2: require('../assets/dw-on@3x.png'),
      zoom: 13, // 缩放级别
      pageHeight: window.innerHeight,
      show1: false,
      show2: false,
      show3: false,
      elepoId: '', // 设备编号
      dtuStatus: '', // 设备状态
      mlName: '', // 所属线路
      longitudeLatitude: '', // 设备位置longitude latitude
      longitude: '',
      latitude: '',
      sbPoint: {}, // 设备所在位置
      myPoint: {}, // 自己当前所在位置的经纬度
      getDistance: '', // 距离
      station: '', // 地理位置
      points: [], // 地图所有坐标点对象
      diaresVO: {},
      list: [],
      sblng: '', // 手机设备所在经度
      sblat: '', // 手机设备所在纬度

      // diaresVO: {
      //   acciId: 'T0002174',
      //   acciTimeFormat1: '2021/03/11 11:47:49.699',
      //   diaRemark: '2021-03-11 11:47:49.699毫秒，10kV523叶盛线AB相过流I段保护分闸，重合闸成功，故障区间：叶盛主线3号杆塔与叶盛主线87号杆塔之间，故障杆塔：叶盛主线3号杆塔大号侧1350米，在叶盛主线30号杆塔附近，青铜峡供电公司（叶盛线）。（技术支持：4001330288）',
      //   diaTypeName: '速断故障',
      //   fixedType: 1,
      //   mlName: '叶盛主线',
      //   mlineId: 'M0184',
      //   readType: ''
      // },
      // list: [
      //   {
      //     dtuId: '',
      //     dtuStatus: 1,
      //     elepoId: '87号杆塔',
      //     latitude: 38.063272,
      //     longitude: 106.097968,
      //     mlineId: 'M0184'
      //   },
      //   {
      //     dtuId: '',
      //     dtuStatus: 1,
      //     elepoId: '83号杆塔',
      //     latitude: 38.033272,
      //     longitude: 109.109968,
      //     mlineId: 'M0184'
      //   },
      //   {
      //     dtuId: '',
      //     dtuStatus: 2,
      //     elepoId: '82号杆塔',
      //     latitude: 38.003272,
      //     longitude: 106.097968,
      //     mlineId: 'M0184'
      //   }
      // ],
      listType: [
        1, 2
      ]// 设备状态 1架空型 2电缆型 3开关型
    }
  },
  mounted () {
    this.getDiaresDetail()// 故障详情接口
    this.getLocation()
  },
  created () {
  },
  methods: {
    getLocation () {
      let vm = this
      console.log(navigator.geolocation)
      if (navigator.geolocation) {
        // console.log('定位开始')
        navigator.geolocation.getCurrentPosition(vm.showPosition, vm.showError, {
          enableHighAcuracy: true, // 指示浏览器获取高精度的位置，默认为false
          timeout: 15000 // 指定获取地理位置的超时时间，默认不限时，单位为毫秒
          // maximumAge: 15000// 最长有效期，在重复获取地理位置时，此参数指定多久再次获取位置。
        })
      } else {
        //alert('浏览器不支持地理定位!')
        Dialog.alert({
          title: '',
          message: '浏览器不支持地理定位!',
        }).then(() => {
          // on close
        });
      }
    },
    showPosition (position) {
      let vm = this
      let pointArr = []
      var lat = position.coords.latitude // 纬度
      var lag = position.coords.longitude // 经度
      // alert('纬度:' + lat + ',经度:' + lag)
      let pt = new window.BMap.Point(lag, lat)
      // alert(position.coords.longitude);
      var convertor = new window.BMap.Convertor()
      pointArr.push(pt)
      // convertor.translate(pointArr, 1, 5, this.translateCallback)
      // 坐标转换完之后的回调函数

      convertor.translate(pointArr, 1, 5, function (resPoint) {
        if (resPoint && resPoint.points && resPoint.points.length > 0) {
          vm.sblng = resPoint.points[0].lng
          vm.sblat = resPoint.points[0].lat
        }

        // alert('经度' + vm.sblng + '--' + vm.sblat)// 准的经纬度
      })
    },
    showError (error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          Dialog.alert({
            title: '',
            message: '定位失败,用户拒绝请求地理定位',
          }).then(() => {
            // on close
          });
          //alert('定位失败,用户拒绝请求地理定位')
          break
        case error.POSITION_UNAVAILABLE:
          Dialog.alert({
            title: '',
            message: '定位失败,位置信息是不可用,请前往应用管理设置获取位置信息的权限',
          }).then(() => {
            // on close
          });
          //alert('定位失败,位置信息是不可用,请开启手机GPS定位')
          break
        case error.TIMEOUT:
          Dialog.alert({
            title: '',
            message: '定位失败,请求获取用户位置超时,请检查手机GPS定位是否开启',
          }).then(() => {
            // on close
          });
          //alert('定位失败,请求获取用户位置超时')
          break
        case error.UNKNOWN_ERROR:
          Dialog.alert({
            title: '',
            message: '定位失败,定位系统失效',
          }).then(() => {
            // on close
          });
          //alert('定位失败,定位系统失效')
          break
      }
    },
    getDiaresDetail () {
      this.util.post('/getDiaresDetail', {
        acciId: this.$route.query.acciId // 故障id
      }).then(({ data }) => {
        if (data.code === 200) {
          // console.log(data)
          this.diaresVO = data.data.diaresVO
          this.list = data.data.list// 地图上需要展示的信息
          this.listType = data.data.listType// 设备状态 1架空型 2电缆型 3开关型

          // 控制图例是否显示 1架空型 2电缆型 3开关型
          for (var i = 0; i < this.listType.length; i++) {
            if (this.listType[i] === 1) {
              this.show2 = true
            } else if (this.listType[i] === 2) {
              this.show3 = true
            } else if (this.listType[i] === 3) {
              this.show1 = true
            }
          }

          this.initMap()
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    todeviceStatus () {
      this.$router.push({
        path: '/deviceStatusPage' // 跳转到设备状态页
      })
    },
    initMap () {
      this.createMap() // 创建地图
      this.setMapEvent()// 设置地图事件
      this.addMapControl()// 向地图添加控件
      this.addMarker()// 向地图中添加marker
      setTimeout(() => {
        this.setViewport()// 设置地图视野层级
      }, 200)

      // this.chageIcon()
    },

    createMap () {
      // eslint-disable-next-line no-undef
      var map = new BMap.Map(this.$refs.allmap)// 在百度地图容器中创建一个地图
      // eslint-disable-next-line no-undef
      // var point = new BMap.Point(106.097968, 38.063272)// 定义一个中心点坐标
      // map.centerAndZoom(point, 13)// 设定地图的中心点和坐标并将地图显示在地图容器中
      window.map = map// 将map变量存储在全局
      map.enableScrollWheelZoom(true)// 允许鼠标滑轮放大缩小
    },
    setViewport () {
      if (this.list.length === 0) {
        var geolocation = new window.BMap.Geolocation()
        geolocation.getCurrentPosition(function getinfo (position) {
          let city = position.address.city // 获取城市信息
          window.map.centerAndZoom(city, 10)// 默认定位到用户所在城市
        }, function (e) {
          // alert('获取百度定位位置信息失败')
        }, { provider: 'baidu' })
      } else {
        window.map.setViewport(this.points)// 根据提供的地理区域或坐标设置地图视野，调整后的视野会保证包含提供的地理区域或坐标
        // window.map.setZoom(window.map.getZoom() - 1)
      }
    },
    setMapEvent () {
      window.map.enableDragging()// 启用地图拖拽事件，默认启用(可不写)
      window.map.enableScrollWheelZoom()// 启用地图滚轮放大缩小
      window.map.enableDoubleClickZoom()// 启用鼠标双击放大，默认启用(可不写)
      window.map.enableKeyboard()// 启用键盘上下左右键移动地图
    },
    addMapControl () {
      // 创建定位控件
    },
    addMarker () {
      let markerArr = this.list
      var marker = []// 定义数组点对象信息
      // eslint-disable-next-line no-array-constructor
      var pointArr = []
      for (var i = 0; i < markerArr.length; i++) { // 遍历
        // var infoA = markerArr[i].point.split('|')[0]// 分割|
        // var infoB = markerArr[i].point.split('|')[1]
        var infoA = markerArr[i].longitude
        var infoB = markerArr[i].latitude

        let point = new window.BMap.Point(infoA, infoB)

        pointArr.push(point)

        // map.setViewport(point)

        marker[i] = new window.BMap.Marker(point[i])

        // 自定义图标
        // const map = new BMap.Map('Map')
        // const point = new BMap.Point(116.404, 39.915)
        let iconSize2 = new window.BMap.Size(24, 24)
        let iconSize3 = new window.BMap.Size(31, 51)
        let dlxIcon2 = new window.BMap.Icon(require('../assets/map/dlx.svg'), iconSize2)// 电缆
        let dlxIcon3 = new window.BMap.Icon(require('../assets/map/dlx-on.svg'), iconSize3, {
          // eslint-disable-next-line no-undef
          // offset: new BMap.Size(30, 160)//
        })

        // eslint-disable-next-line no-undef
        let jksIcon2 = new window.BMap.Icon(require('../assets/map/jkx.svg'), iconSize2)// 架空
        // eslint-disable-next-line no-undef
        let jksIcon3 = new window.BMap.Icon(require('../assets/map/jkx-on.svg'), iconSize3)

        // 开关型
        let kghIcon2 = new window.BMap.Icon(require('../assets/map/dlqh.svg'), iconSize2)// 合
        let kghIcon3 = new window.BMap.Icon(require('../assets/map/dlqh-on.svg'), iconSize3)
        let kgfIcon2 = new window.BMap.Icon(require('../assets/map/dlqf.svg'), iconSize2)// 分
        let kgfIcon3 = new window.BMap.Icon(require('../assets/map/dlqf-on.svg'), iconSize3)
        let kgycIcon2 = new window.BMap.Icon(require('../assets/map/txdk.svg'), iconSize2)// 异常
        let kgycIcon3 = new window.BMap.Icon(require('../assets/map/txdk-on.svg'), iconSize3)

        // 判断
        let vm = this
        if (markerArr[i].dtuStatus === 1) {
          // 架空型设备
          marker[i] = new window.BMap.Marker(point, {
            icon: jksIcon2
          })
          window.map.addOverlay(marker[i])
          var label = new window.BMap.Label(markerArr[i].mlName + markerArr[i].elepoId, { offset: new window.BMap.Size(-25, -20) })
          label.setStyle({
            color: '#353535',
            fontSize: '12px',
            backgroundColor: '0.01',
            border: '0',
            textShadow: '#ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0, #ffffff 0 -1px 0'
          })
          marker[i].setLabel(label)

          let myMarker = marker[i]
          let myMarkerArr = markerArr[i]

          marker[i].addEventListener('click', function () {
            for (let index = 0; index < marker.length; index++) {
              if (marker[index].getLabel().content !== this.getLabel().content) {
                // 别的图标未选中状态
                if (marker[index].getIcon().imageUrl.indexOf('jkx') !== -1) {
                  marker[index].setIcon(jksIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('dlx') !== -1) {
                  marker[index].setIcon(dlxIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('dlqh') !== -1) {
                  marker[index].setIcon(kghIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('dlqf') !== -1) {
                  marker[index].setIcon(kgfIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('txdk') !== -1) {
                  marker[index].setIcon(kgycIcon2)
                }
              }
            }

            // vm.chageIcon(myMarker)// 清除marker
            vm.mapshow = true
            vm.distanceshow = false
            myMarker.setIcon(jksIcon3)// 设置图标
            vm.mlName = myMarkerArr.mlName // 所属线路
            vm.longitudeLatitude = myMarkerArr.elepoId // 设备位置longitude latitude
            var point = new window.BMap.Point(myMarkerArr.longitude, myMarkerArr.latitude)
            vm.longitude = myMarkerArr.longitude
            vm.latitude = myMarkerArr.latitude
            var gc = new window.BMap.Geocoder()
            gc.getLocation(point, function (rs) {
              vm.station = rs.addressComponents.province + rs.addressComponents.city + rs.addressComponents.district + rs.addressComponents.street + rs.addressComponents.streetNumber // 地理位置
            })
            // map.centerAndZoom(point, 13)// 设定地图的中心点和坐标并将地图显示在地图容器中
            window.map.setCenter(point)
            window.map.panBy(0, -100)// 将地图在水平位置上移动x像素，垂直位置上移动y像素
          })
          // vm.mapClick(myMarker)
        } else if (markerArr[i].dtuStatus === 2) {
          // 电缆型设备
          marker[i] = new window.BMap.Marker(point, {
            icon: dlxIcon2
          })
          window.map.addOverlay(marker[i])
          // eslint-disable-next-line no-redeclare
          var label = new window.BMap.Label(markerArr[i].mlName + markerArr[i].elepoId, { offset: new window.BMap.Size(-25, -20) })
          label.setStyle({
            color: '#353535',
            fontSize: '12px',
            backgroundColor: '0.01',
            border: '0',
            textShadow: '#ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0, #ffffff 0 -1px 0'
          })
          marker[i].setLabel(label)
          let myMarker = marker[i]
          let myMarkerArr = markerArr[i]
          marker[i].addEventListener('click', function () {
            vm.mapshow = true
            vm.distanceshow = false
            // 将其它标注都是设置为未选中状态
            for (let index = 0; index < marker.length; index++) {
              if (marker[index].getLabel().content !== this.getLabel().content) {
                // // 别的图标未选中状态
                // console.log(marker[index].getIcon())
                // console.log(marker[index].getIcon().imageUrl)
                if (marker[index].getIcon().imageUrl.indexOf('jkx') !== -1) {
                  marker[index].setIcon(jksIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('dlx') !== -1) {
                  marker[index].setIcon(dlxIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('dlqh') !== -1) {
                  marker[index].setIcon(kghIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('dlqf') !== -1) {
                  marker[index].setIcon(kgfIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('txdk') !== -1) {
                  marker[index].setIcon(kgycIcon2)
                }
                // marker[index].setIcon(dlxIcon2)

                // break
              }
            }
            myMarker.setIcon(dlxIcon3)// 设置图标
            // eslint-disable-next-line no-undef
            //  vm.elepoId=, // 设备编号
            // vm.dtuStatus=, // 设备状态
            vm.mlName = vm.diaresVO.mlName // 所属线路
            vm.longitudeLatitude = myMarkerArr.elepoId // 设备位置longitude latitude
            var point = new window.BMap.Point(myMarkerArr.longitude, myMarkerArr.latitude)
            vm.longitude = myMarkerArr.longitude
            vm.latitude = myMarkerArr.latitude
            var gc = new window.BMap.Geocoder()
            gc.getLocation(point, function (rs) {
              vm.station = rs.addressComponents.province + rs.addressComponents.city + rs.addressComponents.district + rs.addressComponents.street + rs.addressComponents.streetNumber // 地理位置
            })
            window.map.setCenter(point)
            window.map.panBy(0, -100)// 将地图在水平位置上移动x像素，垂直位置上移动y像素
          })
          // vm.mapClick(myMarker)
          window.map.addEventListener('click', function (e) {
            // let allOverlay = window.map.getOverlays()
            // console.log(allOverlay)
            if (e.overlay) {
              // alert('你点击的是覆盖物：' + e.overlay.toString())
              // eslint-disable-next-line no-undef
              vm.mapshow = true
              // eslint-disable-next-line no-undef
              vm.distanceshow = false
              setTimeout(() => {
                this.isActive1 = true
                this.isActive2 = true
              }, 10)
              setTimeout(() => {
                this.isActive1 = false
                this.isActive2 = false
              }, 50)
            } else {
              // alert('你点击的是地图')
              setTimeout(() => {
                this.isActive1 = true
                this.isActive2 = false
                this.isActive3 = true
              }, 10)

              // eslint-disable-next-line no-undef
              vm.mapshow = false
              // 所有标注点变为未选中状态
              for (let index = 0; index < marker.length; index++) {
                if (marker[index].getIcon().imageUrl.indexOf('jkx') !== -1) {
                  marker[index].setIcon(jksIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('dlx') !== -1) {
                  marker[index].setIcon(dlxIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('dlqh') !== -1) {
                  marker[index].setIcon(kghIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('dlqf') !== -1) {
                  marker[index].setIcon(kgfIcon2)
                } else if (marker[index].getIcon().imageUrl.indexOf('txdk') !== -1) {
                  marker[index].setIcon(kgycIcon2)
                }
              }
            }
          })
        } else if (markerArr[i].dtuStatus === 3) {
          // 开关型设备
          // kgStatus 开关状态 1合 2分 3异常
          if (markerArr[i].kgStatus === 1) {
            // 合
            marker[i] = new window.BMap.Marker(point, {
              icon: kghIcon2
            })
            window.map.addOverlay(marker[i])
            // eslint-disable-next-line no-redeclare
            var label = new window.BMap.Label(markerArr[i].mlName + markerArr[i].elepoId, { offset: new window.BMap.Size(-25, -20) })
            label.setStyle({
              color: '#353535',
              fontSize: '12px',
              backgroundColor: '0.01',
              border: '0',
              textShadow: '#ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0, #ffffff 0 -1px 0'
            })
            marker[i].setLabel(label)
            let myMarker = marker[i]
            let myMarkerArr = markerArr[i]
            marker[i].addEventListener('click', function () {
            // vm.chageIcon(myMarker)// 清除marker
              vm.mapshow = true
              vm.distanceshow = false
              // 将其它标注都是设置为未选中状态
              for (let index = 0; index < marker.length; index++) {
                if (marker[index].getLabel().content !== this.getLabel().content) {
                // // 别的图标未选中状态
                // console.log(marker[index].getIcon())
                // console.log(marker[index].getIcon().imageUrl)
                  if (marker[index].getIcon().imageUrl.indexOf('jkx') !== -1) {
                    marker[index].setIcon(jksIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlx') !== -1) {
                    marker[index].setIcon(dlxIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqh') !== -1) {
                    marker[index].setIcon(kghIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqf') !== -1) {
                    marker[index].setIcon(kgfIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('txdk') !== -1) {
                    marker[index].setIcon(kgycIcon2)
                  }
                  // marker[index].setIcon(dlxIcon2)

                // break
                }
              }

              myMarker.setIcon(kghIcon3)// 设置图标
              vm.mlName = vm.diaresVO.mlName // 所属线路
              vm.longitudeLatitude = myMarkerArr.elepoId // 设备位置longitude latitude
              // eslint-disable-next-line no-undef
              var point = new BMap.Point(myMarkerArr.longitude, myMarkerArr.latitude)
              vm.longitude = myMarkerArr.longitude
              vm.latitude = myMarkerArr.latitude
              var gc = new window.BMap.Geocoder()
              gc.getLocation(point, function (rs) {
                vm.station = rs.addressComponents.province + rs.addressComponents.city + rs.addressComponents.district + rs.addressComponents.street + rs.addressComponents.streetNumber // 地理位置
              })
              window.map.setCenter(point)
              window.map.panBy(0, -100)// 将地图在水平位置上移动x像素，垂直位置上移动y像素
            })
            // vm.mapClick(myMarker)
            window.map.addEventListener('click', function (e) {
              // let allOverlay = window.map.getOverlays()
              // console.log(allOverlay)
              // console.log(e.domEvent.srcElement.tagName.toUpperCase())
              // console.log(e.overlay)
              if (e.overlay) {
              // alert('你点击的是覆盖物：' + e.overlay.toString())
                vm.mapshow = true
                vm.distanceshow = false
                setTimeout(() => {
                  this.isActive1 = true
                  this.isActive2 = true
                }, 10)
                setTimeout(() => {
                  this.isActive1 = false
                  this.isActive2 = false
                }, 50)
              } else {
              // alert('你点击的是地图')
                setTimeout(() => {
                  this.isActive1 = true
                  this.isActive2 = false
                  this.isActive3 = true
                }, 10)
                vm.mapshow = false
                // 所有标注点变为未选中状态
                for (let index = 0; index < marker.length; index++) {
                  if (marker[index].getIcon().imageUrl.indexOf('jkx') !== -1) {
                    marker[index].setIcon(jksIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlx') !== -1) {
                    marker[index].setIcon(dlxIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqh') !== -1) {
                    marker[index].setIcon(kghIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqf') !== -1) {
                    marker[index].setIcon(kgfIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('txdk') !== -1) {
                    marker[index].setIcon(kgycIcon2)
                  }
                }
              }
            })
          } else if (markerArr[i].kgStatus === 2) {
            // 分
            marker[i] = new window.BMap.Marker(point, {
              icon: kgfIcon2
            })
            window.map.addOverlay(marker[i])
            // eslint-disable-next-line no-redeclare
            var label = new window.BMap.Label(markerArr[i].mlName + markerArr[i].elepoId, { offset: new window.BMap.Size(-25, -20) })
            label.setStyle({
              color: '#353535',
              fontSize: '12px',
              backgroundColor: '0.01',
              border: '0',
              textShadow: '#ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0, #ffffff 0 -1px 0'
            })
            marker[i].setLabel(label)
            let myMarker = marker[i]
            let myMarkerArr = markerArr[i]
            marker[i].addEventListener('click', function () {
            // vm.chageIcon(myMarker)// 清除marker
              vm.mapshow = true
              vm.distanceshow = false
              // 将其它标注都是设置为未选中状态
              for (let index = 0; index < marker.length; index++) {
                if (marker[index].getLabel().content !== this.getLabel().content) {
                  if (marker[index].getIcon().imageUrl.indexOf('jkx') !== -1) {
                    marker[index].setIcon(jksIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlx') !== -1) {
                    marker[index].setIcon(dlxIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqh') !== -1) {
                    marker[index].setIcon(kghIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqf') !== -1) {
                    marker[index].setIcon(kgfIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('txdk') !== -1) {
                    marker[index].setIcon(kgycIcon2)
                  }
                  // marker[index].setIcon(dlxIcon2)
                // break
                }
              }

              myMarker.setIcon(kgfIcon3)// 设置图标
              vm.mlName = vm.diaresVO.mlName // 所属线路
              vm.longitudeLatitude = myMarkerArr.elepoId // 设备位置longitude latitude
              var point = new window.BMap.Point(myMarkerArr.longitude, myMarkerArr.latitude)
              vm.longitude = myMarkerArr.longitude
              vm.latitude = myMarkerArr.latitude
              var gc = new window.BMap.Geocoder()
              gc.getLocation(point, function (rs) {
                vm.station = rs.addressComponents.province + rs.addressComponents.city + rs.addressComponents.district + rs.addressComponents.street + rs.addressComponents.streetNumber // 地理位置
              })
              window.map.setCenter(point)
              window.map.panBy(0, -100)// 将地图在水平位置上移动x像素，垂直位置上移动y像素
            })
            // vm.mapClick(myMarker)
            window.map.addEventListener('click', function (e) {
              // let allOverlay = window.map.getOverlays()
              // console.log(allOverlay)
              // console.log(e.domEvent.srcElement.tagName.toUpperCase())
              // console.log(e.overlay)
              if (e.overlay) {
              // alert('你点击的是覆盖物：' + e.overlay.toString())
                vm.mapshow = true
                vm.distanceshow = false
                setTimeout(() => {
                  this.isActive1 = true
                  this.isActive2 = true
                }, 10)
                setTimeout(() => {
                  this.isActive1 = false
                  this.isActive2 = false
                }, 50)
              } else {
              // alert('你点击的是地图')
                setTimeout(() => {
                  this.isActive1 = true
                  this.isActive2 = false
                  this.isActive3 = true
                }, 10)
                vm.mapshow = false
                // 所有标注点变为未选中状态
                for (let index = 0; index < marker.length; index++) {
                  if (marker[index].getIcon().imageUrl.indexOf('jkx') !== -1) {
                    marker[index].setIcon(jksIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlx') !== -1) {
                    marker[index].setIcon(dlxIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqh') !== -1) {
                    marker[index].setIcon(kghIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqf') !== -1) {
                    marker[index].setIcon(kgfIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('txdk') !== -1) {
                    marker[index].setIcon(kgycIcon2)
                  }
                }
              }
            })
          } else if (markerArr[i].kgStatus === 3) {
            // 异常
            marker[i] = new window.BMap.Marker(point, {
              icon: kgycIcon2
            })
            window.map.addOverlay(marker[i])
            // eslint-disable-next-line no-redeclare
            var label = new window.BMap.Label(markerArr[i].mlName + markerArr[i].elepoId, { offset: new window.BMap.Size(-25, -20) })
            label.setStyle({
              color: '#353535',
              fontSize: '12px',
              backgroundColor: '0.01',
              border: '0',
              textShadow: '#ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0, #ffffff 0 -1px 0'
            })
            marker[i].setLabel(label)
            let myMarker = marker[i]
            let myMarkerArr = markerArr[i]
            marker[i].addEventListener('click', function () {
            // vm.chageIcon(myMarker)// 清除marker
              vm.mapshow = true
              vm.distanceshow = false
              // 将其它标注都是设置为未选中状态
              for (let index = 0; index < marker.length; index++) {
                if (marker[index].getLabel().content !== this.getLabel().content) {
                // eslint-disable-next-line no-undef
                // map.removeOverlay(marker[index])
                // // 别的图标未选中状态
                // console.log(marker[index].getIcon())
                // console.log(marker[index].getIcon().imageUrl)
                  if (marker[index].getIcon().imageUrl.indexOf('jkx') !== -1) {
                    marker[index].setIcon(jksIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlx') !== -1) {
                    marker[index].setIcon(dlxIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqh') !== -1) {
                    marker[index].setIcon(kghIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqf') !== -1) {
                    marker[index].setIcon(kgfIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('txdk') !== -1) {
                    marker[index].setIcon(kgycIcon2)
                  }
                  // marker[index].setIcon(dlxIcon2)

                // break
                }
              }

              myMarker.setIcon(kgycIcon3)// 设置图标
              vm.mlName = vm.diaresVO.mlName // 所属线路
              vm.longitudeLatitude = myMarkerArr.elepoId // 设备位置longitude latitude
              // eslint-disable-next-line no-undef
              var point = new window.BMap.Point(myMarkerArr.longitude, myMarkerArr.latitude)
              vm.longitude = myMarkerArr.longitude
              vm.latitude = myMarkerArr.latitude
              var gc = new window.BMap.Geocoder()
              gc.getLocation(point, function (rs) {
                vm.station = rs.addressComponents.province + rs.addressComponents.city + rs.addressComponents.district + rs.addressComponents.street + rs.addressComponents.streetNumber // 地理位置
              })
              window.map.setCenter(point)
              window.map.panBy(0, -100)// 将地图在水平位置上移动x像素，垂直位置上移动y像素
            })
            // vm.mapClick(myMarker)
            window.map.addEventListener('click', function (e) {
              if (e.overlay) {
              // alert('你点击的是覆盖物：' + e.overlay.toString())
                vm.mapshow = true
                vm.distanceshow = false
                setTimeout(() => {
                  this.isActive1 = true
                  this.isActive2 = true
                }, 10)
                setTimeout(() => {
                  this.isActive1 = false
                  this.isActive2 = false
                }, 50)
              } else {
              // alert('你点击的是地图')
                setTimeout(() => {
                  this.isActive1 = true
                  this.isActive2 = false
                  this.isActive3 = true
                }, 10)

                // eslint-disable-next-line no-undef
                vm.mapshow = false
                // 所有标注点变为未选中状态
                for (let index = 0; index < marker.length; index++) {
                  if (marker[index].getIcon().imageUrl.indexOf('jkx') !== -1) {
                    marker[index].setIcon(jksIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlx') !== -1) {
                    marker[index].setIcon(dlxIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqh') !== -1) {
                    marker[index].setIcon(kghIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('dlqf') !== -1) {
                    marker[index].setIcon(kgfIcon2)
                  } else if (marker[index].getIcon().imageUrl.indexOf('txdk') !== -1) {
                    marker[index].setIcon(kgycIcon2)
                  }
                }
              }
            })
          }
        }
      }
      this.points = pointArr
      window.map.setViewport(this.points)// 根据提供的地理区域或坐标设置地图视野，调整后的视野会保证包含提供的地理区域或坐标
    },

    // 点击定位-定位到当前位置
    fixedPos (collect) {
      let vm = this
      vm.collect = !collect
      // alert(vm.sblng + '---' + vm.sblat)
      var point = new window.BMap.Point(vm.sblng, vm.sblat)// 用当前定位的经纬度查找省市区街道等信息
      var myIcon = new window.BMap.Icon(
        require('../assets/map/dw.svg'), new window.BMap.Size(25, 25)
      )
      // eslint-disable-next-line no-undef
      var marker = new BMap.Marker(point, {
        icon: myIcon
      })
      // 将标注添加到地图
      window.map.addOverlay(marker)
      window.map.setCenter(point)// 设置中心点
      window.map.setZoom(window.map.getZoom() - 1)
    },
    startTOend () {
      let vm = this
      var allOverlay = window.map.getOverlays()
      // 百度地图删除折线覆盖物
      for (var i = 0; i < allOverlay.length; i++) {
        // console.log(allOverlay[i].toString())
        if (allOverlay[i].toString().indexOf('Polyline') > 0) { // 删除折线
          window.map.removeOverlay(allOverlay[i])
        }
      }

      // if (geoStatus === BMAP_STATUS_SUCCESS) {
      const point = new window.BMap.Point(vm.sblng, vm.sblat)
      vm.myPoint = point
      // var output = '从西单到上地驾车需要'
      var searchComplete = function (results) {
        // eslint-disable-next-line no-undef
        if (transit.getStatus() !== BMAP_STATUS_SUCCESS) {
          return
        }
        var plan = results.getPlan(0)
        // output += plan.getDuration(true) + '\n' // 获取时间
        // output += '总路程为：'
        // output += plan.getDistance(true) + '\n' // 获取距离
        vm.getDistance = plan.getDistance(true)
      }
      // eslint-disable-next-line no-undef
      var start = point // 纠正后的位置
      // console.log(point)
      var end = new window.BMap.Point(vm.longitude, vm.latitude)// 终点

      // 自定义图标
      var startIcon = new window.BMap.Icon(
        require('../assets/map/fxzn.svg'),
        new window.BMap.Size(25, 25), { offset: new window.BMap.Size(50, -55) }
        // new BMap.Size(25, 25), { offset: new BMap.Size(40, -140) }
      )
      var endIcon = new window.BMap.Icon(
        require('../assets/dw@3x.png'),
        new window.BMap.Size(0, 0)
      )
      var transit = new window.BMap.DrivingRoute(window.map, { renderOptions: { map: window.map },
        onSearchComplete: searchComplete,
        onPolylinesSet: function (Route) {
          // setTimeout(function () { alert(output) }, '1000')
          for (var i = 0; i < Route.length - 1; i++) {
            var polyline = Route[i].getPolyline() // 获取线条遮挡物
            polyline.setStrokeColor('#0B7DEC') // 设置颜色
            polyline.setStrokeWeight(6) // 设置宽度
            polyline.setStrokeOpacity(0.8) // 设置透明度
          }
        },
        onMarkersSet: function (routes) {
          window.map.removeOverlay(routes[0].marker) // 删除起点
          window.map.removeOverlay(routes[1].marker)// 删除终点
          window.map.removeOverlay(routes[routes.length - 1].marker)

          for (var m = 1; m < routes.length - 1; m++) {
            if (routes[m].title !== '起点' || routes[m].title !== '终点') {
              var mm = routes[m].Um
              window.map.removeOverlay(mm)
              window.map.removeOverlay(routes[m].marker)
            }
            // eslint-disable-next-line no-redeclare
            var mm = routes[m].Nm
            window.map.removeOverlay(mm)
          }
          // 标注点完成回调
          // eslint-disable-next-line no-undef
          // map.clearOverlays() // 删除点
          var myStart = new window.BMap.Marker(start, { icon: startIcon })
          window.map.addOverlay(myStart) // 添加自定义起点图标
          var myEnd = new window.BMap.Marker(end, { icon: endIcon })
          window.map.addOverlay(myEnd) // 添加自定义终点图标
          // var myCurrent = new BMap.Marker(current, { icon: currentIcon })
          // map.addOverlay(myCurrent) // 添加自定义途径点图标
        }
      })
      // eslint-disable-next-line no-undef
      // var start = new BMap.Point(116.404844, 39.911836)// 起始点
      // var end = new BMap.Point(116.308102, 40.056057)// 终点
      // eslint-disable-next-line no-undef

      transit.search(start, end, { waypoints: [end] })
      vm.distanceshow = true
      vm.mapshow = false

      // }, { enableHighAccuracy: true })// 是否要求浏览器获取最佳效果，同浏览器定位接口参数
    },
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1)// 返回上一页面
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-dropdown-menu__bar {
  height: 34px;
}
/deep/.van-nav-bar__content {
  height: 46px;
  // background: url("../assets/gzxqbj@3x.png") no-repeat top center;
  // background-size: 100% 100%;
  background: #0B7DEC;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}

.van-button {
  vertical-align: middle;
}
.xltj i:nth-of-type(1) {
  width: 9px;
  height: 9px;
  background: #e85b45;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
.xltj i:nth-of-type(2) {
  float: right;
}
.pickitem {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  color: #565656;
  font-size: 13px;
}
.pickitem.onpick {
  border: 1px solid #0b7dec;
  color: #0b7dec;
}
.item em {
  float: right;
  color: #a2a1a0;
  font-size: 12px;
  margin-top: 3px;
}

.datetimepicker {
  padding: 18px 12px;
}
.datetimepicker .van-col {
  text-align: center;
}
.datetimepicker input {
  width: 40vw;
  background: #ebebeb;
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  text-align: center;
}
.btnitem {
  width: 40vw;
  font-size: 15px;
}
.reset {
  color: #0b7dec !important;
}
</style>
